export const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL
export const DEVELOPER_MIMIK_URL = process.env.REACT_APP_DEVELOPER_MIMIK_URL